// 3rd Party
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

// Components
import { ColorIcon } from 'common/styles/oc-styled-components';

// Other
import { colors, NAV_HEIGHT } from 'common/styles/style-constants';
import { DIMENSIONS } from 'providers/WindowDimensionsProvider';
import scrollToRef from 'utils/scrollToRef';

import { NAVIGATION_BAR_TABS } from '../../constants/constants';

import {
  NavButton,
  NavItem,
  NavTitle,
  NavWrapper,
  NavListItem,
  StyledContainer,
} from './styled-components';

// Component
const Navigation = ({
  layout,
  refToProviders,
  refToNeedToKnow,
  refToOfficeDetails,
  refToReviews,
}) => {
  const [highlighted, setHighlighted] = useState();
  useEffect(() => {
    const scrollHandler = () => {
      const offsetTop = window.scrollY + (NAV_HEIGHT + 10);

      // logic to determine which Navigation tab to be highlighted, depening on the user's scroll position
      if (offsetTop < _.get(refToOfficeDetails, 'current.offsetTop')) {
        if (highlighted !== NAVIGATION_BAR_TABS.needToKnow) {
          setHighlighted(NAVIGATION_BAR_TABS.needToKnow);
        }
      } else if (
        offsetTop > _.get(refToNeedToKnow, 'current.offsetTop')
        && offsetTop < _.get(refToProviders, 'current.offsetTop')
      ) {
        if (highlighted !== NAVIGATION_BAR_TABS.office) {
          setHighlighted(NAVIGATION_BAR_TABS.office);
        }
      } else if (
        offsetTop > _.get(refToOfficeDetails, 'current.offsetTop')
        && offsetTop < _.get(refToReviews, 'current.offsetTop')
      ) {
        if (highlighted !== NAVIGATION_BAR_TABS.about) {
          setHighlighted(NAVIGATION_BAR_TABS.about);
        }
      } else if (highlighted !== NAVIGATION_BAR_TABS.reviews) {
        setHighlighted(NAVIGATION_BAR_TABS.reviews);
      }
    };

    window.addEventListener('scroll', scrollHandler);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  const getRefForNavItem = navItem => {
    switch (navItem) {
      case NAVIGATION_BAR_TABS.needToKnow:
        return refToNeedToKnow;
      case NAVIGATION_BAR_TABS.office:
        return refToOfficeDetails;
      case NAVIGATION_BAR_TABS.about:
        return refToProviders;
      case NAVIGATION_BAR_TABS.reviews:
        return refToReviews;
      default:
        return undefined;
    }
  };

  const navigation = {
    [NAVIGATION_BAR_TABS.needToKnow]: {
      label: layout === DIMENSIONS.MOBILE ? 'Overview' : 'Need to know',
      icon: 'thunderbolt',
    },
    [NAVIGATION_BAR_TABS.office]: {
      label: 'Office',
      icon: 'home',
    },
    [NAVIGATION_BAR_TABS.about]: {
      label: 'About',
      icon: 'skin',
    },
    [NAVIGATION_BAR_TABS.reviews]: {
      label: 'Reviews',
      icon: 'star',
    },
  };

  return (
    <NavWrapper id="navBar" as="nav">
      <StyledContainer as="ol">
        {Object.keys(navigation).map(navItemKey => {
          const navItem = navigation[navItemKey];
          const isHighlighted = highlighted === navItemKey;
          const ref = getRefForNavItem(navItemKey);

          return (
            <NavListItem key={navItem.label}>
              <NavButton
                highlighted={isHighlighted}
                onClick={() => scrollToRef(ref, NAV_HEIGHT + 10)}
              >
                <NavItem>
                  <ColorIcon
                    color={isHighlighted ? colors.blue : colors.silver}
                    theme="filled"
                    type={navItem.icon}
                    role="presentation"
                    aria-hidden
                  />
                  <NavTitle
                    color={isHighlighted ? colors.blue : colors.slate}
                    margin="0"
                  >
                    {navItem.label}
                  </NavTitle>
                </NavItem>
              </NavButton>
            </NavListItem>
          );
        })}
      </StyledContainer>
    </NavWrapper>
  );
};

Navigation.propTypes = {
  layout: PropTypes.string,
  refToProviders: PropTypes.object,
  refToNeedToKnow: PropTypes.object,
  refToOfficeDetails: PropTypes.object,
  refToReviews: PropTypes.object,
};

export default Navigation;
